import { render, staticRenderFns } from "./IdentificationLogExtraStaff.vue?vue&type=template&id=30c06e67&scoped=true&"
import script from "./IdentificationLogExtraStaff.vue?vue&type=script&lang=js&"
export * from "./IdentificationLogExtraStaff.vue?vue&type=script&lang=js&"
import style0 from "./IdentificationLogExtraStaff.vue?vue&type=style&index=0&id=30c06e67&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c06e67",
  null
  
)

export default component.exports